/**
 * Map an object's stored type (+ discriminator fields) to the renderer key.
 *
 * `sink` is overloaded: legacy kitchen sinks saved before `kitchen-sink`
 * became a top-level type carry `sinkType: 'kitchen'`, and the compact
 * wall-hung bathroom unit carries `sinkType: 'wall-mount'`. Both need their
 * own renderer; every other sink is a basin in a countertop.
 */
const SINK_TYPE_RENDERERS = {
  kitchen: 'kitchen-sink',
  'wall-mount': 'wall-hung-sink',
};

export function resolveProceduralType(objectType, objectData) {
  if (objectType !== 'sink') return objectType;
  return SINK_TYPE_RENDERERS[objectData?.sinkType] || 'sink';
}
